import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Common from "../based/Common";
import { NOTIFY } from "../based/Constants";
import TableFooter from "../based/content/TableFooter";
import LoadingR from "../based/LoadingR";
import { Notify } from "../based/Notify";
import PartnerServices from "../based/services/PartnerServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";

const ManageGroupCustomize = () => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const [msg, setMsg] = useState("Đang tải dữ liệu...");
    const [paging, setPaging] = useState({ ...Common.Paging });
    const [datas, setDatas] = useState([]);

    useEffect(() => {
        getDatas(paging);
    }, []);

    /** Lấy dữ liệu của set */
    const getDatas = async (newPaging) => {
        const [err, data] = await PartnerServices.GetCusSetByPaging(newPaging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging(newPaging);
        }
    };

    const createCusSet = async () => {
        const [err, data] = await PartnerServices.CreateUpdateCusSet({});
        if (!err && data) {
            history.push(`/edit-group-customize/${data.id}`);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra, vui lòng thử lại sau");
        }
    };

    const renderGroup = (groups, index, isCollapse) => {
        let content = [];

        let firstItem = null;
        let subItem = [];
        let viewMore = null;

        for (let index = 0; index < groups.length; index++) {
            const element = groups[index];
            if (index == 0) {
                firstItem = (
                    <div className="list-item">
                        <div
                            className="item"
                            style={{
                                width: "5%",
                            }}
                        ></div>
                        <div
                            className="item"
                            style={{
                                width: "25%",
                            }}
                        >
                            <div className="list-thumbnail">
                                {element.colorGroupItems &&
                                    element.colorGroupItems.map((i, x) => {
                                        return <img src={i.productImageUrl} alt="" />;
                                    })}
                            </div>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "30%",
                            }}
                        >
                            <span className="title">{element.title}</span>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "10%",
                            }}
                        >
                            <div
                                className="span-color"
                                style={{
                                    background: element.colorValue,
                                    color: element.colorValue === "#ffffff" || element.colorValue == "#f7f7f7" ? "#000000" : "#ffffff",
                                }}
                            >
                                <span>{element.colorName}</span>
                            </div>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "10%",
                            }}
                        >
                            <span>0</span>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "10%",
                            }}
                        >
                            <div className="span-status">
                                <span>Đang online</span>
                            </div>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "10%",
                            }}
                        >
                            <div className="list-item-btn">
                                <div
                                    className={`item-btn ${false ? "disable" : ""}`}
                                    onClick={() => {
                                        history.push(`/edit-group-customize/${element.setId}`);
                                    }}
                                >
                                    <div className="icon">
                                        <EditIcon />
                                    </div>
                                    <span>Chỉnh sửa</span>
                                </div>
                                <div
                                    className={`item-btn`}
                                    onClick={(e) => {
                                        window.open(`https://ranus.vn/customize-detail-page/${element.setId}/${element.appProductVariantId}`, "_blank");
                                    }}
                                >
                                    <div className="icon">
                                        <PreviewIcon />
                                    </div>
                                    <span>Xem trang</span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                if (index > 2 && !isCollapse) continue;
                let item = (
                    <div className="list-sub">
                        <div
                            className="item"
                            style={{
                                width: "calc(25% * 100/85)",
                            }}
                        >
                            <div className="list-thumbnail">
                                {element.colorGroupItems &&
                                    element.colorGroupItems.map((i, x) => {
                                        return <img src={i.productImageUrl} alt="" />;
                                    })}
                            </div>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "calc(30% * 100/85)",
                            }}
                        >
                            <span className="title">{element.title}</span>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "calc(10% * 100/85)",
                            }}
                        >
                            <div
                                className="span-color"
                                style={{
                                    background: element.colorValue,
                                    color: element.colorValue === "#ffffff" || element.colorValue == "#f7f7f7" ? "#000000" : "#ffffff",
                                }}
                            >
                                <span>{element.colorName}</span>
                            </div>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "calc(10% * 100/85)",
                            }}
                        >
                            <span>0</span>
                        </div>
                        <div
                            className="item"
                            style={{
                                width: "calc(10% * 100/85)",
                            }}
                        >
                            <div className="span-status">
                                <span>Đang online</span>
                            </div>
                        </div>
                    </div>
                );
                subItem.push(item);
            }
        }

        //nếu có nhiều hơn 3 item thì thêm nút xem thêm
        if (groups.length > 3)
            viewMore = (
                <div
                    className="list-item-btn"
                    onClick={(e) => {
                        let dt = [...datas];
                        let item = dt[index];
                        item.isCollapse = !item.isCollapse;
                        setDatas(dt);
                    }}
                >
                    <div className={`item-btn`}>{!isCollapse ? <span>Xem thêm {groups.length - 3} màu khác</span> : <span>Ẩn màu khác</span>}</div>
                </div>
            );

        //chỉnh lại subItem
        let subItemContent = (
            <div className="sub-list">
                {subItem.map((item, idx) => {
                    return item;
                })}
            </div>
        );

        //chỉnh lại content
        content.push(firstItem);
        content.push(subItemContent);
        content.push(viewMore);

        return content;
    };

    return (
        <React.Fragment>
            <Breadcum menu={["Trang chủ", "Nhóm thiết kế"]} title="Nhóm thiết kế" />
            <LoadingR isShow={isLoading} />
            <Wrapper>
                <div className="header-page">
                    <div className="header-overview">
                        <div className="overview-left">
                            <div className="list-button">
                                <button
                                    className="btn btn-orange"
                                    onClick={(e) => {
                                        createCusSet();
                                    }}
                                >
                                    Thêm nhóm mới
                                </button>
                            </div>
                        </div>
                        <div className="overview-right">
                            <div className="search-area">
                                <input
                                    type="text"
                                    value={paging.keyword}
                                    placeholder="Tìm kiếm thiết kế"
                                    onChange={(e) => {
                                        setPaging({ ...paging, keyword: e.target.value });
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            getDatas({ ...paging });
                                        }
                                    }}
                                />
                                <div
                                    className="icon-subfix"
                                    onClick={(e) => {
                                        getDatas({ ...paging });
                                    }}
                                >
                                    <div className="icon">
                                        <SearchIcon />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="table-artwork-header">
                        <div className="list-item">
                            <div
                                className="item"
                                style={{
                                    width: "5%",
                                }}
                            >
                                <input type="checkbox" />
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "25%",
                                }}
                            >
                                <span>Thiết kế</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "30%",
                                }}
                            >
                                <span>Tên thiết kế</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "10%",
                                }}
                            >
                                <span>Màu</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "10%",
                                }}
                            >
                                <span>Đã bán</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "10%",
                                }}
                            >
                                <span>Trạng thái</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "10%",
                                }}
                            >
                                <span>Thao tác</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-artwork-body">
                    {datas && datas.length > 0 ? (
                        datas.map((item, idx) => {
                            return (
                                <div className="body-item" key={idx}>
                                    {renderGroup(item.colorGroups, idx, item.isCollapse)}
                                </div>
                            );
                        })
                    ) : (
                        <div className="text-center no-data">Không có dữ liệu</div>
                    )}

                    <TableFooter itemToDisplay={2} onFilter={(paging) => getDatas({ ...paging })} paging={paging} />
                </div>
            </Wrapper>
        </React.Fragment>
    );
};

export default ManageGroupCustomize;

const Wrapper = styled.div`
    width: 90%;
    .view-more {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 38px;
        margin-top: 10px;
    }

    .body-item {
        border-radius: 12px;
        border: 1px solid #f1f1f1;
        background: #fff;
        padding: 10px 16px;
        margin: 10px 0;
    }

    .list-sub {
        display: flex;
        align-items: center;
    }

    .sub-list {
        border-radius: 8px;
        border: 1px solid #e5e5e4;
        background: #f3f3f3;
        margin-left: 5%;
        margin-right: 10%;
    }

    .span-color {
        display: inline-block;
    }

    .sub-list .list-thumbnail img {
        width: 40%;
    }

    .span-status {
        display: inline-block;
    }

    .list-thumbnail img {
        width: 50%;
        height: auto;
        object-fit: contain;
        border-radius: 4px;
    }

    span.title {
        color: #5e5e5e;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 10px;
    }

    .span-color {
        border-radius: 20px;
        background: #0a0a0a;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 10px 12px;
    }

    .span-status {
        border-radius: 20px;
        background: #ecf8f0;
        color: #28b259;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 10px 12px;
    }

    .list-item-btn {
        padding: 5px;
    }

    .main_instruction {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff5ec;
        padding: 16px;
        margin: 12px 0;
    }

    .title p {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 6px;
    }

    .title ul {
        padding-left: 22px;
        margin-bottom: 0;
    }

    .title ul li {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .title ul li span.high-light {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .list-thumbnail {
        height: 100%;
        width: 100%;
        padding: 10px;
    }

    .no-data {
        background: white;
        margin: 12px 0;
        padding: 12px 24px;
        border-radius: 12px;
        font-weight: 500;
        font-family: Lexend;
    }

    .list-item-btn {
        width: 100%;
        height: 100%;
    }

    .item-btn {
        display: flex;
        align-items: center;
        margin: 6px 0;
        cursor: pointer;
    }

    .item-btn span {
        width: 100%;
        display: flex;
        align-items: center;
        margin: 6px 0;
        color: #13aaff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        margin-left: 4px;

        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .item-btn span .icon {
        margin: 0 12px;
    }

    span.status {
        color: #28b259;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        border-radius: 20px;
        background: #ecf8f0;
        padding: 10px 12px;
    }

    .list-thumbnail {
        display: flex;
    }

    .thumbnail {
        width: 50%;
        height: 100%;
        display: flex;
    }

    .thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .table-artwork-body .list-item .item {
        height: 100%;
        border-right: 1px solid #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .table-artwork-body .list-item .item:last-child {
        border: none;
    }
    .table-artwork-body .list-item {
    }
    .list-item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .item {
        text-align: center;
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: var(--Cam-Thng-hiu, #ff9027);
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 10px 12px;
    }

    .header-overview {
        display: flex;
        align-items: center;
    }

    .overview-right {
        width: 500px;
        margin-left: auto;
        display: flex;
        margin-left: auto;
    }

    .search-area {
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 12px 16px 12px 20px;
        margin-right: 12px;
    }

    .search-area input[type="text"] {
        border: none;
        width: 100%;
    }

    .overview-right {
        flex: 1;
    }

    .search-area {
        width: 100%;
    }

    .status-options {
        width: 200px;
        display: flex;
        align-items: center;
    }

    .status-options > div {
        width: 100%;
    }

    .react-select__control {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        padding: 11px 13px;
    }

    hr {
        border: 1px solid #f3f3f3 !important;
        width: 100%;
    }

    .overview-left {
        display: flex;
        width: 60%;
        flex-wrap: wrap;
    }

    .overview-area {
        border-radius: 10px;
        background: #f8f8f8;
        padding: 6px 16px;
        margin: 6px;
    }

    .overview-area label {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .overview-value {
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .header-top {
        display: flex;
        flex: 1;
    }

    .btn-add-new {
        border-radius: 40px;
        background: #ff9027;
        display: flex;
        align-items: center;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 13px 18px;
        align-items: center;
        cursor: pointer;
    }

    .icon {
        display: flex;
        margin-left: 14px;
    }

    .add-new {
        margin-left: auto;
    }

    .header-page {
        display: flex;
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 10px 16px;
        flex-direction: column;
    }

    .box__header {
        display: flex;
        align-items: center;
    }

    .btn-tab {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 6px;
        cursor: pointer;
        padding: 12px 18px;
    }

    .btn-tab.active {
        border-radius: 8px;
        background: #fff5ec;
        color: #ff9027;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
`;

const AddNewIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
            <path d="M7.5 1V13" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.5 7L1.5 7" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

const SearchIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path
                d="M8.67414 16.1886C12.9125 16.1886 16.3483 12.7885 16.3483 8.5943C16.3483 4.40008 12.9125 1 8.67414 1C4.43583 1 1 4.40008 1 8.5943C1 12.7885 4.43583 16.1886 8.67414 16.1886Z"
                stroke="#303030"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M14.312 14.1736L18.0861 17.9084" stroke="#303030" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

const EditIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 19H19" stroke="#13AAFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M14.5 2.49998C14.8978 2.10216 15.4374 1.87866 16 1.87866C16.2786 1.87866 16.5544 1.93353 16.8118 2.04014C17.0692 2.14674 17.303 2.303 17.5 2.49998C17.697 2.69697 17.8532 2.93082 17.9598 3.18819C18.0665 3.44556 18.1213 3.72141 18.1213 3.99998C18.1213 4.27856 18.0665 4.55441 17.9598 4.81178C17.8532 5.06915 17.697 5.303 17.5 5.49998L5 18L1 19L2 15L14.5 2.49998Z"
                stroke="#13AAFF"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

const PreviewIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 12C2 12 5.63636 5 12 5C18.3636 5 22 12 22 12C22 12 18.3636 19 12 19C5.63636 19 2 12 2 12Z" stroke="#13AAFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#13AAFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

const HideIcon = () => {
    return (
        <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.6 15.4C7.15401 16.5846 9.04627 17.2408 11 17.2728C17.3636 17.2728 21 10 21 10C19.8692 7.89268 18.3008 6.05151 16.4 4.60005M12.9091 2.9455C12.2833 2.79903 11.6427 2.72581 11 2.72732C4.63636 2.72732 0.999999 10 0.999999 10C1.55184 11.0324 2.20995 12.0043 2.96364 12.9M9.07273 11.9273C9.32241 12.1953 9.6235 12.4102 9.95804 12.5592C10.2926 12.7083 10.6537 12.7885 11.0199 12.7949C11.3861 12.8014 11.7499 12.734 12.0894 12.5969C12.429 12.4597 12.7375 12.2555 12.9965 11.9965C13.2555 11.7376 13.4596 11.4291 13.5968 11.0895C13.734 10.7499 13.8013 10.3862 13.7949 10.02C13.7884 9.65377 13.7083 9.29263 13.5592 8.95809C13.4101 8.62355 13.1952 8.32245 12.9273 8.07277"
                stroke="#13AAFF"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M19.1821 1.81836L2.81849 18.182" stroke="#13AAFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

const RemoveIcon = () => {
    return (
        <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.2209 20H5.69325C4.4908 20 3.54601 19.1515 3.37423 17.9636L2 6H16L14.5399 17.9636C14.3681 19.1515 13.4233 20 12.2209 20Z"
                stroke="#13AAFF"
                stroke-width="1.8"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M1 3.5H17" stroke="#13AAFF" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round" />
            <path d="M6.41699 1H11.7504" stroke="#13AAFF" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round" />
            <path d="M7 9.6665L7.36356 15.3333" stroke="#13AAFF" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.9997 9.6665L10.5635 15.3333" stroke="#13AAFF" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};
